import {actionNames} from 'constants/index';
const mapDispatchToProps = dispatch => ({
    SOLICITUD_EMPADRONAMIENTO_SET_STEP: (step)=> 
        dispatch({ "type":actionNames.SOLICITUD_EMPADRONAMIENTO_SET_STEP,"state":{"step":step}}),    
    SOLICITUD_EMPADRONAMIENTO_SET_ES_RECHAZADO_O_EMPADRONADO: (esRechazadoOEmpadronado)=> 
        dispatch({ "type":actionNames.SOLICITUD_EMPADRONAMIENTO_SET_ES_RECHAZADO_O_EMPADRONADO,"state":{"esRechazadoOEmpadronado":esRechazadoOEmpadronado}}),    
    SOLICITUD_EMPADRONAMIENTO_SET_CATALOGOS_DE_RECHAZO_DE_CIUDADANO: (data)=> 
        dispatch({ "type":actionNames.SOLICITUD_EMPADRONAMIENTO_SET_CATALOGOS_DE_RECHAZO_DE_CIUDADANO,payload: data}),
    SOLICITUD_EMPADRONAMIENTO_SET_CATALOGOS_DE_RECHAZO_DE_INTERNO: (data)=> 
        dispatch({ "type":actionNames.SOLICITUD_EMPADRONAMIENTO_SET_CATALOGOS_DE_RECHAZO_DE_INTERNO,payload: data}),        
    });
export default mapDispatchToProps;